export function scrollToTop(top: number = 0, smooth: boolean = true) {
  document.body.scrollTo({
    top,
    behavior: smooth ? 'smooth' : 'instant',
  });
  window.scrollTo({
    top,
    behavior: smooth ? 'smooth' : 'instant',
  });
}
